/* @flow */
import React, { Component } from 'react';
import type UIComponent from 'components/UIKit/types';

import Row from './Row';

const Column: UIComponent = (props) => {
    let { children, style, ref, ...rest } = props; // eslint-disable-line no-redeclare

    return (
      <Row {...rest} style={{...style, flexDirection: 'column' }} ref={ref}>
        {children}
      </Row>
    );
}

export default Column;